import { post } from '../helpers/axiosHelper'

const url = `https://windon.encyon.se/api/contact.php`

const submitContact = async (data) => post(`${url}`, data)

export default {
  submitContact
}
